/** Medição de rede: fontes de chamadas lidas do Zoom e do Webex (R02-08) e testes sintéticos a partir das estações (R02-09). */
const en = {
  'nmx.src.title': 'Sources read from the platforms',
  'nmx.src.list': 'Call sources',
  'nmx.src.kind': 'Platform',
  'nmx.src.connection': 'Connection',
  'nmx.src.enabled': 'Reading',
  'nmx.src.enabledLabel': 'Read {name}',
  'nmx.src.lastAt': 'Last reading',
  'nmx.src.lastCalls': 'Calls in the last reading',
  'nmx.src.state': 'State',
  'nmx.src.ok': 'OK',
  'nmx.src.failed': 'Failed',
  'nmx.src.off': 'Off',
  'nmx.src.never': 'Never read',
  'nmx.src.read': 'Read now',
  'nmx.src.reading': 'Reading…',
  'nmx.src.readDone': '{n} calls read.',
  'nmx.src.changed': 'Reading changed.',
  'nmx.src.connect': 'Connect Zoom or Webex',
  'nmx.src.empty': 'No platform connected',
  'nmx.src.emptyText': 'Teams uses the Microsoft Entra connection; Zoom (Server-to-Server OAuth app) and Webex (integration with refresh token) have their own cards in Integrations › Calls and meetings. Each participant of each meeting becomes a call here, read every 15 minutes.',
  'nmx.src.kind.teams': 'Microsoft Teams',
  'nmx.src.kind.zoom': 'Zoom',
  'nmx.src.kind.webex': 'Webex',
  'nmx.cl.bitrate': 'Bitrate',
  'nmx.cl.kbps': '{n} kbps',
  'nmx.sy.tabs': 'Where the tests run',
  'nmx.sy.tab.browser': 'Browser (collector)',
  'nmx.sy.tab.endpoint': 'From workstations',
  'nmx.et.list': 'Workstation tests',
  'nmx.et.new': 'New workstation test',
  'nmx.et.editTitle': 'Edit {name}',
  'nmx.et.empty': 'No workstation test yet',
  'nmx.et.emptyText': 'Point an HTTP, TCP, DNS or HTTP-steps test at groups or tags of workstations to measure from the user\'s point of view, at the branch or at home.',
  'nmx.et.name': 'Name',
  'nmx.et.kind': 'Kind',
  'nmx.et.kind.http': 'HTTP',
  'nmx.et.kind.tcp': 'TCP port',
  'nmx.et.kind.dns': 'DNS',
  'nmx.et.kind.steps': 'HTTP steps (no browser)',
  'nmx.et.target': 'Target',
  'nmx.et.targetUrl': 'Address',
  'nmx.et.targetTcp': 'Host and port',
  'nmx.et.targetDns': 'Name to resolve',
  'nmx.et.scope': 'Workstations',
  'nmx.et.groups': 'Workstation groups',
  'nmx.et.tags': 'Tags (comma-separated)',
  'nmx.et.every': 'Every',
  'nmx.et.everyText': '{n} min',
  'nmx.et.timeout': 'Time limit',
  'nmx.et.timeoutText': '{n} s',
  'nmx.et.method': 'Method',
  'nmx.et.expectStatus': 'Expected status (blank = below 400)',
  'nmx.et.expectText': 'Expected text',
  'nmx.et.expectAnswer': 'Expected answer (optional)',
  'nmx.et.dnsType': 'Record',
  'nmx.et.step': 'Step {n}',
  'nmx.et.stepUrl': 'Address of step {n}',
  'nmx.et.body': 'Body (JSON, no secrets)',
  'nmx.et.addStep': 'Add step',
  'nmx.et.removeStep': 'Remove step {n}',
  'nmx.et.allowCred': 'Send the credential to the workstations',
  'nmx.et.allowCredHint': 'Without this mark the credential never leaves the Hive and the test runs without it.',
  'nmx.et.header': 'Header name',
  'nmx.et.secret': 'Header value (stored in the vault)',
  'nmx.et.secretKeep': 'Blank keeps the stored value; type - to remove it.',
  'nmx.et.enabled': 'On',
  'nmx.et.save': 'Save',
  'nmx.et.cancel': 'Cancel',
  'nmx.et.edit': 'Edit',
  'nmx.et.delete': 'Delete',
  'nmx.et.saved': 'Test saved: it reaches the workstations in the next policy.',
  'nmx.et.deleted': 'Test deleted.',
  'nmx.et.p.name': 'Give the test a name.',
  'nmx.et.p.target': 'Check the target of the test.',
  'nmx.et.p.steps': 'Each step needs an http:// or https:// address (1 to 10 steps).',
  'nmx.et.p.scope': 'Choose at least one group or tag of workstations.',
  'nmx.et.p.credential': 'Mark "Send the credential to the workstations" to keep a credential.',
  'nmx.et.agents': 'Workstations (24 h)',
  'nmx.et.okPct': 'Success (24 h)',
  'nmx.et.p95': 'p95 (24 h)',
  'nmx.et.lastAt': 'Last result',
  'nmx.et.never': 'No result yet',
  'nmx.et.cred': 'Credential',
  'nmx.et.credYes': 'goes to the workstations',
  'nmx.et.credNo': 'stays in the Hive',
  'nmx.et.byLocation': 'Office × home × VPN',
  'nmx.et.bySite': 'By site',
  'nmx.et.byGroup': 'By group',
  'nmx.et.worst': 'Worst workstations',
  'nmx.et.recent': 'Last runs',
  'nmx.et.loc.office': 'Office',
  'nmx.et.loc.home': 'Home',
  'nmx.et.loc.vpn': 'VPN',
  'nmx.et.loc.unknown': 'Unknown',
  'nmx.et.noSite': 'No site',
  'nmx.et.runs': 'Runs',
  'nmx.et.failures': 'Failures',
  'nmx.et.host': 'Workstation',
  'nmx.et.site': 'Site',
  'nmx.et.location': 'Where',
  'nmx.et.p50': 'p50',
  'nmx.et.p95Short': 'p95',
  'nmx.et.ok': 'Success',
  'nmx.et.error': 'Last error',
  'nmx.et.at': 'When',
  'nmx.et.result': 'Result',
  'nmx.et.time': 'Time',
  'nmx.et.okShort': 'OK',
  'nmx.et.failShort': 'Failed',
  'nmx.et.homeSlower': 'At home the p95 is {ms} higher than at the office.',
  'nmx.et.homeFaster': 'At home the p95 is {ms} lower than at the office.',
  'nmx.et.noResults': 'No result yet: each workstation runs the test within one interval after receiving the policy.',
  'nmx.et.how': 'The test goes in the agent policy of the workstations in the groups and tags; each one runs it by itself, one test at a time, with at most 30 s and the first run spread over the interval. Office = IP in an IPAM subnet; VPN = the route goes through a VPN interface; the rest is home.',
};

type Keys = keyof typeof en;

const ptBR: Record<Keys, string> = {
  'nmx.src.title': 'Fontes lidas das plataformas',
  'nmx.src.list': 'Fontes de chamadas',
  'nmx.src.kind': 'Plataforma',
  'nmx.src.connection': 'Conexão',
  'nmx.src.enabled': 'Leitura',
  'nmx.src.enabledLabel': 'Ler {name}',
  'nmx.src.lastAt': 'Última leitura',
  'nmx.src.lastCalls': 'Chamadas na última leitura',
  'nmx.src.state': 'Estado',
  'nmx.src.ok': 'OK',
  'nmx.src.failed': 'Falhou',
  'nmx.src.off': 'Desligada',
  'nmx.src.never': 'Nunca lida',
  'nmx.src.read': 'Ler agora',
  'nmx.src.reading': 'Lendo…',
  'nmx.src.readDone': '{n} chamadas lidas.',
  'nmx.src.changed': 'Leitura alterada.',
  'nmx.src.connect': 'Conectar Zoom ou Webex',
  'nmx.src.empty': 'Nenhuma plataforma conectada',
  'nmx.src.emptyText': 'O Teams usa a conexão do Microsoft Entra; o Zoom (aplicativo Server-to-Server OAuth) e o Webex (integração com refresh token) têm cartões próprios em Integrações › Chamadas e reuniões. Cada participante de cada reunião vira uma chamada aqui, lida a cada 15 minutos.',
  'nmx.src.kind.teams': 'Microsoft Teams',
  'nmx.src.kind.zoom': 'Zoom',
  'nmx.src.kind.webex': 'Webex',
  'nmx.cl.bitrate': 'Taxa de bits',
  'nmx.cl.kbps': '{n} kbps',
  'nmx.sy.tabs': 'Onde os testes rodam',
  'nmx.sy.tab.browser': 'Navegador (coletor)',
  'nmx.sy.tab.endpoint': 'A partir das estações',
  'nmx.et.list': 'Testes das estações',
  'nmx.et.new': 'Novo teste das estações',
  'nmx.et.editTitle': 'Editar {name}',
  'nmx.et.empty': 'Nenhum teste das estações ainda',
  'nmx.et.emptyText': 'Aponte um teste HTTP, TCP, DNS ou de passos HTTP para grupos ou tags de estações e meça do ponto de vista do usuário, na filial ou em casa.',
  'nmx.et.name': 'Nome',
  'nmx.et.kind': 'Tipo',
  'nmx.et.kind.http': 'HTTP',
  'nmx.et.kind.tcp': 'Porta TCP',
  'nmx.et.kind.dns': 'DNS',
  'nmx.et.kind.steps': 'Passos HTTP (sem navegador)',
  'nmx.et.target': 'Alvo',
  'nmx.et.targetUrl': 'Endereço',
  'nmx.et.targetTcp': 'Host e porta',
  'nmx.et.targetDns': 'Nome a resolver',
  'nmx.et.scope': 'Estações',
  'nmx.et.groups': 'Grupos de estações',
  'nmx.et.tags': 'Tags (separadas por vírgula)',
  'nmx.et.every': 'A cada',
  'nmx.et.everyText': '{n} min',
  'nmx.et.timeout': 'Tempo limite',
  'nmx.et.timeoutText': '{n} s',
  'nmx.et.method': 'Método',
  'nmx.et.expectStatus': 'Status esperado (em branco = abaixo de 400)',
  'nmx.et.expectText': 'Texto esperado',
  'nmx.et.expectAnswer': 'Resposta esperada (opcional)',
  'nmx.et.dnsType': 'Registro',
  'nmx.et.step': 'Passo {n}',
  'nmx.et.stepUrl': 'Endereço do passo {n}',
  'nmx.et.body': 'Corpo (JSON, sem segredos)',
  'nmx.et.addStep': 'Adicionar passo',
  'nmx.et.removeStep': 'Remover o passo {n}',
  'nmx.et.allowCred': 'Enviar a credencial às estações',
  'nmx.et.allowCredHint': 'Sem esta marca, a credencial nunca sai do Hive e o teste roda sem ela.',
  'nmx.et.header': 'Nome do cabeçalho',
  'nmx.et.secret': 'Valor do cabeçalho (guardado no cofre)',
  'nmx.et.secretKeep': 'Em branco mantém o valor guardado; digite - para apagar.',
  'nmx.et.enabled': 'Ligado',
  'nmx.et.save': 'Salvar',
  'nmx.et.cancel': 'Cancelar',
  'nmx.et.edit': 'Editar',
  'nmx.et.delete': 'Apagar',
  'nmx.et.saved': 'Teste salvo: chega às estações na próxima política.',
  'nmx.et.deleted': 'Teste apagado.',
  'nmx.et.p.name': 'Dê um nome ao teste.',
  'nmx.et.p.target': 'Confira o alvo do teste.',
  'nmx.et.p.steps': 'Cada passo precisa de um endereço http:// ou https:// (de 1 a 10 passos).',
  'nmx.et.p.scope': 'Escolha pelo menos um grupo ou tag de estações.',
  'nmx.et.p.credential': 'Marque "Enviar a credencial às estações" para guardar uma credencial.',
  'nmx.et.agents': 'Estações (24 h)',
  'nmx.et.okPct': 'Sucesso (24 h)',
  'nmx.et.p95': 'p95 (24 h)',
  'nmx.et.lastAt': 'Último resultado',
  'nmx.et.never': 'Sem resultado ainda',
  'nmx.et.cred': 'Credencial',
  'nmx.et.credYes': 'vai às estações',
  'nmx.et.credNo': 'fica no Hive',
  'nmx.et.byLocation': 'Escritório × casa × VPN',
  'nmx.et.bySite': 'Por site',
  'nmx.et.byGroup': 'Por grupo',
  'nmx.et.worst': 'Piores estações',
  'nmx.et.recent': 'Últimas execuções',
  'nmx.et.loc.office': 'Escritório',
  'nmx.et.loc.home': 'Casa',
  'nmx.et.loc.vpn': 'VPN',
  'nmx.et.loc.unknown': 'Não sabido',
  'nmx.et.noSite': 'Sem site',
  'nmx.et.runs': 'Execuções',
  'nmx.et.failures': 'Falhas',
  'nmx.et.host': 'Estação',
  'nmx.et.site': 'Site',
  'nmx.et.location': 'Onde',
  'nmx.et.p50': 'p50',
  'nmx.et.p95Short': 'p95',
  'nmx.et.ok': 'Sucesso',
  'nmx.et.error': 'Último erro',
  'nmx.et.at': 'Quando',
  'nmx.et.result': 'Resultado',
  'nmx.et.time': 'Tempo',
  'nmx.et.okShort': 'OK',
  'nmx.et.failShort': 'Falhou',
  'nmx.et.homeSlower': 'Em casa o p95 é {ms} maior que no escritório.',
  'nmx.et.homeFaster': 'Em casa o p95 é {ms} menor que no escritório.',
  'nmx.et.noResults': 'Sem resultado ainda: cada estação roda o teste dentro de um intervalo depois de receber a política.',
  'nmx.et.how': 'O teste vai na política do agente das estações dos grupos e tags; cada uma roda sozinha, um teste de cada vez, com no máximo 30 s e a primeira execução espalhada no intervalo. Escritório = IP numa sub-rede do IPAM; VPN = a rota passa por uma interface de VPN; o resto é casa.',
};

const es: Record<Keys, string> = {
  'nmx.src.title': 'Fuentes leídas de las plataformas',
  'nmx.src.list': 'Fuentes de llamadas',
  'nmx.src.kind': 'Plataforma',
  'nmx.src.connection': 'Conexión',
  'nmx.src.enabled': 'Lectura',
  'nmx.src.enabledLabel': 'Leer {name}',
  'nmx.src.lastAt': 'Última lectura',
  'nmx.src.lastCalls': 'Llamadas en la última lectura',
  'nmx.src.state': 'Estado',
  'nmx.src.ok': 'OK',
  'nmx.src.failed': 'Falló',
  'nmx.src.off': 'Desactivada',
  'nmx.src.never': 'Nunca leída',
  'nmx.src.read': 'Leer ahora',
  'nmx.src.reading': 'Leyendo…',
  'nmx.src.readDone': '{n} llamadas leídas.',
  'nmx.src.changed': 'Lectura cambiada.',
  'nmx.src.connect': 'Conectar Zoom o Webex',
  'nmx.src.empty': 'Ninguna plataforma conectada',
  'nmx.src.emptyText': 'Teams usa la conexión de Microsoft Entra; Zoom (aplicación Server-to-Server OAuth) y Webex (integración con refresh token) tienen tarjetas propias en Integraciones › Llamadas y reuniones. Cada participante de cada reunión se vuelve una llamada aquí, leída cada 15 minutos.',
  'nmx.src.kind.teams': 'Microsoft Teams',
  'nmx.src.kind.zoom': 'Zoom',
  'nmx.src.kind.webex': 'Webex',
  'nmx.cl.bitrate': 'Tasa de bits',
  'nmx.cl.kbps': '{n} kbps',
  'nmx.sy.tabs': 'Dónde corren las pruebas',
  'nmx.sy.tab.browser': 'Navegador (colector)',
  'nmx.sy.tab.endpoint': 'Desde las estaciones',
  'nmx.et.list': 'Pruebas de las estaciones',
  'nmx.et.new': 'Nueva prueba de las estaciones',
  'nmx.et.editTitle': 'Editar {name}',
  'nmx.et.empty': 'Ninguna prueba de las estaciones aún',
  'nmx.et.emptyText': 'Apunte una prueba HTTP, TCP, DNS o de pasos HTTP a grupos o etiquetas de estaciones y mida desde el punto de vista del usuario, en la sucursal o en casa.',
  'nmx.et.name': 'Nombre',
  'nmx.et.kind': 'Tipo',
  'nmx.et.kind.http': 'HTTP',
  'nmx.et.kind.tcp': 'Puerto TCP',
  'nmx.et.kind.dns': 'DNS',
  'nmx.et.kind.steps': 'Pasos HTTP (sin navegador)',
  'nmx.et.target': 'Destino',
  'nmx.et.targetUrl': 'Dirección',
  'nmx.et.targetTcp': 'Host y puerto',
  'nmx.et.targetDns': 'Nombre a resolver',
  'nmx.et.scope': 'Estaciones',
  'nmx.et.groups': 'Grupos de estaciones',
  'nmx.et.tags': 'Etiquetas (separadas por coma)',
  'nmx.et.every': 'Cada',
  'nmx.et.everyText': '{n} min',
  'nmx.et.timeout': 'Tiempo límite',
  'nmx.et.timeoutText': '{n} s',
  'nmx.et.method': 'Método',
  'nmx.et.expectStatus': 'Estado esperado (en blanco = menor que 400)',
  'nmx.et.expectText': 'Texto esperado',
  'nmx.et.expectAnswer': 'Respuesta esperada (opcional)',
  'nmx.et.dnsType': 'Registro',
  'nmx.et.step': 'Paso {n}',
  'nmx.et.stepUrl': 'Dirección del paso {n}',
  'nmx.et.body': 'Cuerpo (JSON, sin secretos)',
  'nmx.et.addStep': 'Agregar paso',
  'nmx.et.removeStep': 'Quitar el paso {n}',
  'nmx.et.allowCred': 'Enviar la credencial a las estaciones',
  'nmx.et.allowCredHint': 'Sin esta marca, la credencial nunca sale de Hive y la prueba corre sin ella.',
  'nmx.et.header': 'Nombre del encabezado',
  'nmx.et.secret': 'Valor del encabezado (guardado en la bóveda)',
  'nmx.et.secretKeep': 'En blanco mantiene el valor guardado; escriba - para borrarlo.',
  'nmx.et.enabled': 'Activada',
  'nmx.et.save': 'Guardar',
  'nmx.et.cancel': 'Cancelar',
  'nmx.et.edit': 'Editar',
  'nmx.et.delete': 'Borrar',
  'nmx.et.saved': 'Prueba guardada: llega a las estaciones en la próxima política.',
  'nmx.et.deleted': 'Prueba borrada.',
  'nmx.et.p.name': 'Dé un nombre a la prueba.',
  'nmx.et.p.target': 'Revise el destino de la prueba.',
  'nmx.et.p.steps': 'Cada paso necesita una dirección http:// o https:// (de 1 a 10 pasos).',
  'nmx.et.p.scope': 'Elija al menos un grupo o etiqueta de estaciones.',
  'nmx.et.p.credential': 'Marque "Enviar la credencial a las estaciones" para guardar una credencial.',
  'nmx.et.agents': 'Estaciones (24 h)',
  'nmx.et.okPct': 'Éxito (24 h)',
  'nmx.et.p95': 'p95 (24 h)',
  'nmx.et.lastAt': 'Último resultado',
  'nmx.et.never': 'Sin resultado aún',
  'nmx.et.cred': 'Credencial',
  'nmx.et.credYes': 'va a las estaciones',
  'nmx.et.credNo': 'queda en Hive',
  'nmx.et.byLocation': 'Oficina × casa × VPN',
  'nmx.et.bySite': 'Por sitio',
  'nmx.et.byGroup': 'Por grupo',
  'nmx.et.worst': 'Peores estaciones',
  'nmx.et.recent': 'Últimas ejecuciones',
  'nmx.et.loc.office': 'Oficina',
  'nmx.et.loc.home': 'Casa',
  'nmx.et.loc.vpn': 'VPN',
  'nmx.et.loc.unknown': 'Desconocido',
  'nmx.et.noSite': 'Sin sitio',
  'nmx.et.runs': 'Ejecuciones',
  'nmx.et.failures': 'Fallas',
  'nmx.et.host': 'Estación',
  'nmx.et.site': 'Sitio',
  'nmx.et.location': 'Dónde',
  'nmx.et.p50': 'p50',
  'nmx.et.p95Short': 'p95',
  'nmx.et.ok': 'Éxito',
  'nmx.et.error': 'Último error',
  'nmx.et.at': 'Cuándo',
  'nmx.et.result': 'Resultado',
  'nmx.et.time': 'Tiempo',
  'nmx.et.okShort': 'OK',
  'nmx.et.failShort': 'Falló',
  'nmx.et.homeSlower': 'En casa el p95 es {ms} mayor que en la oficina.',
  'nmx.et.homeFaster': 'En casa el p95 es {ms} menor que en la oficina.',
  'nmx.et.noResults': 'Sin resultado aún: cada estación corre la prueba dentro de un intervalo después de recibir la política.',
  'nmx.et.how': 'La prueba va en la política del agente de las estaciones de los grupos y etiquetas; cada una la corre sola, una prueba a la vez, con 30 s como máximo y la primera ejecución repartida en el intervalo. Oficina = IP en una subred del IPAM; VPN = la ruta pasa por una interfaz de VPN; el resto es casa.',
};

export const nmUcSynthMessages = { en, 'pt-BR': ptBR, es } as const;
